import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../lib/api';

const POLL_MS = 5 * 60 * 1000; // projections don't change during the day

export function useWatchlistCards(tickers) {
  const [cards, setCards] = useState({});
  const [loading, setLoading] = useState(true);

  const param = Array.isArray(tickers) ? tickers.join(',') : (tickers || '');

  const doFetch = useCallback(async () => {
    if (!param) {
      setLoading(false);
      return;
    }
    try {
      const res = await apiClient.get('/api/projections/watchlist', {
        params: { tickers: param },
      });
      const map = {};
      for (const card of res.data) map[card.ticker] = card;
      setCards(map);
    } catch {
      // retain previous data on transient error
    } finally {
      setLoading(false);
    }
  }, [param]);

  useEffect(() => { doFetch(); }, [doFetch]);

  useEffect(() => {
    const id = setTimeout(doFetch, POLL_MS);
    return () => clearTimeout(id);
  }, [doFetch]);

  return { cards, loading };
}
